export default "__VITE_ASSET__CD6J_jIz__"